export default {"src":"/_next/static/media/lighting-design.39ceeb8d.svg","height":25,"width":17,"blurWidth":0,"blurHeight":0};